export default __webpack_public_path__ + "static/react-1d315b8eb4125a98e0efc47770e467fe.png";